import React from "react";
import { Link } from "react-router-dom";
import {Header, Footer, CTA} from "./App.js";
import Seo from "./Seo";


export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <Seo
        title="Services: DocInsight, SAP-Support & Carve-Out | JUMIBI"
        description="KI-gestützte Dokumentenautomatisierung, SAP-Projektunterstützung sowie Carve-Out- und Due-Diligence-Support. Pragmatisch, skalierbar und messbar wirksam."
      />
      {/* Hero / Header Section */}
<section
  id="ServiceHero"
  className="relative pt-28 pb-20 flex flex-col items-center justify-center bg-center bg-cover text-white text-center px-6"
  style={{
    backgroundImage:
      `linear-gradient(180deg, rgba(10,20,40,0.75), rgba(10,20,40,0.65)), url('${process.env.PUBLIC_URL}/images/services-hero.png')`,
  }}
>
  <h1 className="text-4xl md:text-5xl font-bold mb-6">Services</h1>
  <p className="text-lg md:text-xl max-w-3xl mx-auto mb-4">
    We provide a wide range of Services
  </p>
  <p className="text-base md:text-lg max-w-3xl mx-auto mb-2">
    At JUMIBI Consulting, we offer tailored IT services – from intelligent document automation to SAP project support and complex carve-out initiatives.
  </p>
  <p className="text-base md:text-lg max-w-3xl mx-auto">
    Our solutions are pragmatic, scalable, and above all: effective. Together, we bring efficiency, structure, and digital power to your business.
  </p>
</section>

      {/* Intro Section */}
      <section id="ServicesIntro" className="max-w-6xl mx-auto px-6 py-16 space-y-6 text-center">
        <p className="text-gray-700 text-lg font-semibold">How can we help you?</p>
        <p className="text-gray-700 text-lg">
          Whether you’re looking for AI-powered document automation, support with SAP projects, or strategic data transitions – we’re here to help.
        </p>
        <p className="text-gray-700 text-lg">
          Our flagship product DocInsight delivers fast wins. Our consulting team makes them sustainable.
        </p>

      </section>

      {/* Services List */}
      <section id="ServicesList" className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-8">
        {[
          {
            title: "DocInsight",
            desc: "Our flagship tool automates invoice capture, validation, and SAP integration. Fast to deploy, logic-driven, and built for measurable time savings."
          },
          {
            title: "SAP Project Support",
            desc: "We assist in SAP-related projects – from interface setup to approval flows and functional coordination. Practical support, embedded in real operations."
          },
          {
            title: "Carve-Out & Data Projects",
            desc: "We guide data separations during M&A, IT transitions, and reorganizations. Structured, compliant, and close to the process."
          },
          {
            title: "Due Diligence Support",
            desc: "We prepare clean, audit-ready data for investors, buyers, and finance teams. Lean coordination with maximum clarity."
          },
          {
            title: "Application Management",
            desc: "We handle small changes, incidents, and maintenance after go-live. Stable operations, without long-term lock-in."
          },
          {
            title: "Custom Modules",
            desc: "We develop lightweight tools to close ERP and workflow gaps. Reports, logic, UI – tailored to your needs."
          }
        ].map((service, idx) => (
          <article key={idx} className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
            <p className="text-gray-600">{service.desc}</p>
          </article>
        ))}
      </section>


      <CTA />
      <Footer />
    </div>
  );
}
